<div class="ps">
  <div class="ps__card">

    <!-- Verifying -->
    <div class="ps__state" *ngIf="verifying">
      <div class="ps__spinner"></div>
      <h2 class="ps__title">Verifying Payment…</h2>
      <p class="ps__desc">Please wait while we confirm your payment with Paystack.</p>
    </div>

    <!-- Success -->
    <div class="ps__state" *ngIf="!verifying && success">
      <div class="ps__icon ps__icon--success">✓</div>
      <h2 class="ps__title">Payment Successful!</h2>
      <p class="ps__desc">
        Your <strong>{{ planName }}</strong> subscription is now active.
      </p>
      <button class="ps__btn" (click)="goToDashboard()">
        Go to Dashboard
      </button>
    </div>

    <!-- Error -->
    <div class="ps__state" *ngIf="!verifying && !success">
      <div class="ps__icon ps__icon--error">✗</div>
      <h2 class="ps__title">Verification Failed</h2>
      <p class="ps__desc">{{ error }}</p>
      <button class="ps__btn ps__btn--secondary" (click)="goToDashboard()">
        Back to Dashboard
      </button>
    </div>

  </div>
</div>